export default __webpack_public_path__ + "static/media/panda.d59bafc9.png";